import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import Repeater from '@Utils/Repeater';
import ArsenalArmyComponent from './ArsenalArmyComponent';
import { myArsenalArmiesPresenter } from '@Selectors/arsenal/myArsenalArmiesPresenter';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { defaultMessages } from '@I18n/default';
import { ArsenalArmyView } from '@Selectors/arsenal/make/view/ArsenalArmyView';
import myBuilderSlice from '@Redux/reducers/builder/myBuilder.slice';
import { MyBuilderActionState } from '@Stores/builder/MyBuilderState';
import bt_new_paint_list from '@Images/en/bt_new_paint_list.png';

const MyArsenalArmiesComponent: React.FC<MyArsenalArmiesComponentProps> = ({ arsenalArmies, create }) => {
  return (
    <section>
      <h2 className="text-center"><FormattedMessage {...defaultMessages.arsenalArmiesIndexTitle} /></h2>
      <Row className="content justify-content-center">
        <Col xs={6} md={3} lg={3} xl={2} className="army_list_row text-center">
          <a href="#" onClick={(e) => create(e)}>
            <img src={`${process.env.CDN ?? ''}${bt_new_paint_list}`} className="img-fluid w-100" alt="" />
            <h4 className="boxtitre"><FormattedMessage {...defaultMessages.paintListIndexAdd} /></h4>
          </a>
        </Col>
        <Repeater data={arsenalArmies} indexPrefix="arsenal-army">
          {
            (item: ArsenalArmyView) => <ArsenalArmyComponent army={item} />
          }
        </Repeater>
      </Row>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  arsenalArmies: myArsenalArmiesPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  create: (e: any) => {
    e.preventDefault();
    dispatch(myBuilderSlice.actions.setRequest(MyBuilderActionState.ArsenalArmyCreation));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MyArsenalArmiesComponent);

type MyArsenalArmiesComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
